import { render } from "./UploadFileModal.vue?vue&type=template&id=7096ad5c&scoped=true"
import script from "./UploadFileModal.vue?vue&type=script&lang=js"
export * from "./UploadFileModal.vue?vue&type=script&lang=js"

import "./UploadFileModal.vue?vue&type=style&index=0&id=7096ad5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7096ad5c"]])

export default __exports__